import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ShFormNumberInputComponent, ShPageHeaderComponent } from '@stylehaven/components';

import { NgLetModule } from 'ng-let';
import { DigihavenDirectiveModule } from '../directives/directive.module';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe';
import { RecordModule } from '../record/record.module';
import { RecordService } from '../record/services/record.service';
import { PrintAmountDialogComponent } from './components/print-amount-dialog/print-amount-dialog.component';
import { PrintLabelComponent } from './components/print-label/print-label.component';
import { LabelPrintOverviewContainerComponent } from './containers/label-print-overview/label-print-overview-container.component';
import { RecordListPrintOverviewComponent } from './containers/record-list-print-overview/record-list-print-overview.component';
import { LabelPrintSandboxService } from './sandbox/label-print-sandbox.service';
import { PrintService } from './services/print.service';
import { RecordPrintService } from './services/record-print.service';

@NgModule({
    declarations: [
        LabelPrintOverviewContainerComponent,
        PrintLabelComponent,
        PrintAmountDialogComponent,
        RecordListPrintOverviewComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        RecordModule,
        ReactiveFormsModule,
        DigihavenDirectiveModule,
        ShPageHeaderComponent,
        ReadableDatePipeModule,
        NgLetModule,
        ShFormNumberInputComponent
    ],
    providers: [RecordService, LabelPrintSandboxService, PrintService, RecordPrintService],
    exports: [LabelPrintOverviewContainerComponent]
})
export class PrintModule {}
export { LabelPrintOverviewContainerComponent } from './containers/label-print-overview/label-print-overview-container.component';
export { RecordListPrintOverviewComponent } from './containers/record-list-print-overview/record-list-print-overview.component';
export * from './entities/print.entity';
export { PrintLabelActionCreator } from './services/print-label-action.creator';
export { PrintService } from './services/print.service';
export { RecordPrintService } from './services/record-print.service';
